<template>
  <v-container fluid>
    <ValidationObserver ref="observer" v-slot="{ validate, reset }">
      <v-dialog v-model="dialog" max-width="850px">
        <v-title color="secondary">Dealer Logins</v-title>
        <v-card>
          <v-card-text>
            <edit-company-details :dealerManager.sync="editedItem" />
            <edit-address-details :dealerManager.sync="editedItem" />
            <edit-channel-details
              v-if="editedItem.dealerID !== 0"
              :dealerManager.sync="editedItem"
              :admins="admins"
            />
            <edit-director-details :dealerManager.sync="editedItem" />
            <edit-banking-details :dealerManager.sync="editedItem" />

            <v-flex class="pb-3">
              <v-layout>
                <v-flex>
                  <v-btn @click="deleteDealer" color="error">
                    Delete
                  </v-btn>
                </v-flex>
                <v-flex text-xs-right>
                  <v-btn @click="save" color="primary">Save</v-btn>
                  <v-btn @click="undo" color="light-grey">Cancel</v-btn>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-card-text>
        </v-card>
      </v-dialog>
      <loader-dialog
        :showLoader="processingUpdate"
        :stockDialog="true"
      ></loader-dialog>

      <div>
        <v-layout row>
          <v-flex xs4>
            <v-text-field
              name="Search"
              label="Search"
              v-model="SearchText"
              append-icon="search"
            ></v-text-field>
          </v-flex>
        </v-layout>
      </div>
      <v-data-table
        xs12
        :total-items="totalItems"
        :pagination.sync="pagination"
        :items="filteredRows"
        :headers="headers"
        :loading="loading"
      >
        <template slot="items" slot-scope="props">
          <td
            v-for="(prop, propIndex) in headers.filter(
              x => x.text !== 'Actions'
            )"
            :key="propIndex"
            :class="'ma-0'"
          >
            <div v-if="prop.autocomplete" :class="'text-xs-' + prop.align">
              {{ props.item[prop.value][prop.nested] }}
            </div>

            <div v-else :class="'text-xs-' + prop.align">
              {{ props.item[prop.value] }}
            </div>
          </td>
          <td class="justify-center layout px-0">
            <v-btn icon class="mx-0" @click="editItem(props.item)">
              <v-icon color="teal">edit</v-icon>
            </v-btn>
          </td>
        </template>
      </v-data-table>
      <v-layout row>
        <v-flex xs12>
          <message-alert :component="message"></message-alert>
        </v-flex>
      </v-layout>
    </ValidationObserver>
  </v-container>
</template>

<script>
import { mapActions, createNamespacedHelpers } from 'vuex';
import { DealerManager } from '@/models/dealerPortal/DealerManager';
import { httpError } from '@/models/httpError';
const { mapActions: mapAuthActions } = createNamespacedHelpers(`orders/auth`);
const {
  mapActions: mapRegisterActions,
  mapMutations: mapRegisterMutations,
} = createNamespacedHelpers(`register`);
const { mapActions: mapDealerActions } = createNamespacedHelpers(
  `orders/dealer`
);
import {
  mapRegisterFields,
  mapRegisterMultiRowFields,
} from '@/store/modules/register';
import EditCompanyDetails from './editDealerContract/edit-company-details.vue';
import EditAddressDetails from './editDealerContract/edit-address-details.vue';
import EditChannelDetails from './editDealerContract/edit-channel-details.vue';
import EditDirectorDetails from './editDealerContract/edit-director-details.vue';
import EditBankingDetails from './editDealerContract/edit-banking-details.vue';
import LoaderDialog from '@/components/common/LoaderDialog';

export default {
  name: 'edit-dealer-contract',
  components: {
    EditCompanyDetails,
    EditAddressDetails,
    EditChannelDetails,
    EditDirectorDetails,
    EditBankingDetails,
    LoaderDialog,
  },
  data() {
    return {
      showRejected: false,
      dialog: false,
      editedItem: new DealerManager(),
      editedIndex: 0,
      valid: true,
      SearchText: null,
      items: [],
      totalItems: 0,
      pagination: {
        page: 1,
        rowsPerPage: 20,
        totalItems: 0,
        descending: true,
      },
      loading: false,
      processingUpdate: false,
      headers: [
        {
          text: 'ID',
          align: 'right',
          sortable: true,
          value: 'ubDealerID',
        },
        {
          text: 'Company',
          align: 'left',
          sortable: true,
          value: 'company',
        },
        {
          text: 'Manager',
          align: 'right',
          sortable: true,
          value: 'dealerManagerId',
        },
        {
          text: 'Level',
          align: 'right',
          sortable: true,
          value: 'levelID',
        },
        {
          text: 'Contact Details',
          align: 'right',
          sortable: true,
          value: 'contactDetails',
        },
        {
          text: 'Actions',
          value: 'name',
          sortable: false,
        },
      ],
      admins: [],
    };
  },
  methods: {
    ...mapAuthActions(['getDealerAuths']),
    ...mapRegisterActions([
      'listContracts',
      'setMessage',
      'listDealerManagers',
      'deleteDealerDetails',
    ]),
    ...mapDealerActions(['getDealerManager', 'editDealerManager']),
    isValid: function(item) {
      let vm = this;
      if (vm.SearchText === null) return true;
      const filters = vm.headers.filter(x => x.sortable).map(x => x.value);

      for (var i = 0; i < filters.length; i++) {
        if (typeof item[filters[i]] !== null) {
          let reviewedString = '';
          if (item[filters[i]] !== null)
            reviewedString = item[filters[i]].toString().toUpperCase();
          if (reviewedString.includes(vm.SearchText.toUpperCase())) return true;
        }
      }
    },
    editItem(item) {
      this.setMessage(new httpError());
      this.editedIndex = this.rows.indexOf(item);

      this.getDealerManager(item.ubDealerID).then(result => {
        if (result.status == '' || result.status == null)
          result.status = 'Prospect';
        this.editedItem = result;
        this.dialog = true;
      });
    },
    save() {
      let vm = this;
      vm.dialog = false;
      vm.processingUpdate = true;
      vm.editDealerManager(this.editedItem)
        .then(e => {
          vm.setMessage({ message: e || 'Details Saved!', httpStatus: 200 });
          vm.processingUpdate = false;
        })
        .catch(err => {
          vm.setMessage(
            new httpError({
              message: 'Dealer Not Edited' + err.message,
              httpStatus: 500,
            })
          );
          vm.processingUpdate = false;
        })
        .finally(() => {
          vm.processingUpdate = false;
        });
      vm.listContracts(vm.showRejected)
        .then(data => {
          vm.items = data;
          vm.total = data.length;
          vm.loading = false;
          vm.getDealerManagers();
        })
        .catch(() => {});
    },
    deleteDealer() {
      let vm = this;
      this.setMessage(new httpError());
      let answer = confirm('Are you sure you want to delete this dealer?');
      if (answer) {
        vm.deleteDealerDetails(vm.editedItem.dealerId)
          .then(() => {
            vm.dialog = false;
            vm.getListContracts();
          })
          .catch(() => {});
      }
    },
    getListContracts() {
      let vm = this;
      vm.listContracts(vm.showRejected)
        .then(data => {
          vm.items = data;
          vm.total = data.length;
          vm.loading = false;
          vm.getDealerManagers();
        })
        .catch(() => {});
    },
    getDealerManagers() {
      let vm = this;
      vm.listDealerManagers({}).then(res => {
        vm.admins = res
          .filter(el => el.levelID > 1)
          .sort((a, b) => {
            return +b.levelID - +a.levelID;
          });

        vm.admins.forEach(x => {
          let newText = [];
          let hasAccount = x.accountName !== ' ' && x.accountName !== null;
          let hasCompany =
            x.registeredCompanyName !== ' ' && x.registeredCompanyName !== null;
          let hasDirector = x.directorsName !== ' ' && x.directorsName !== null;

          let account = hasAccount ? x.accountName.toLowerCase() : '';
          let showAccount = true;
          let company = hasCompany ? x.registeredCompanyName.toLowerCase() : '';
          let showCompany = true;
          let director = hasDirector ? x.directorsName.toLowerCase() : '';
          let showDirector = true;

          if (account === company) showCompany = false;
          if (account === director) showDirector = false;
          if (company === director) showDirector = false;

          if (showDirector && hasDirector) newText.push(x.directorsName);
          if (showCompany && hasCompany) newText.push(x.registeredCompanyName);
          if (showAccount && hasAccount) newText.push(x.accountName);

          x.displayText = newText.reverse().join(' - ');
        });
      });
    },
    isEqual(first, second) {
      return first.value.toLowerCase() === second.value.toLowerCase();
    },
    undo() {
      this.dialog = false;
    },
  },
  computed: {
    ...mapRegisterFields(['message']),
    ...mapRegisterMultiRowFields(['rows']),
    filteredRows: function() {
      let vm = this;
      return vm.items.filter(this.isValid);
    },
  },
  mounted() {
    let vm = this;
    vm.getDealerManagers();
    this.listContracts(vm.showRejected)
      .then(data => {
        vm.items = data;
        vm.total = data.length;
        vm.loading = false;
      })
      .catch(err => {});
  },
};
</script>
